<template>
  <main>
    <ChooseCategoryBlock
      v-bind="chooseCategoryBlockProps"
    />
  </main>
</template>

<script>
import ChooseCategoryBlock from '@/components/ChooseCategoryBlock'
import { serializeParameters } from '@/utils/general'
import { WebsiteCategories, WebsiteCategoryCookie } from '@/enums/app'
import { WomenCountries } from '@/enums/general'

export default {
  name: 'ChooseCategoryPage',
  layout: 'homepage-nofooter',
  components: { ChooseCategoryBlock },
  middleware: ({ app, route, redirect, store: { state: { app: { locale, country } } } }) => {
    const category = app.$cookies.get(WebsiteCategoryCookie)
    const i18Params = `/${locale}-${country}`
    const queryParamsString = serializeParameters(route.query)

    if (WomenCountries.includes(country)) {
      if (category) {
        if (WebsiteCategories.men === category) {
          return redirect(`${i18Params}/${category}?${queryParamsString}`)
        }

        return redirect(`${i18Params}/${category}?${queryParamsString}`)
      }
    } else {
      return redirect(`${i18Params}/men?${queryParamsString}`)
    }
  },
  computed: {
    chooseCategoryBlockProps () {
      return {
        image: '/images/frontend/static/mix-campaign',
        title: this.$t('ChooseCategoryPage.ChooseCategory'),
        description: this.$t('ChooseCategoryPage.ChooseCategoryDescription'),
        womenAriaLabel: this.$t('Accessibilty.AriaLabels.GoToWomenHomepage'),
        menAriaLabel: this.$t('Accessibilty.AriaLabels.GoToMenHomepage')
      }
    }
  }
}
</script>
